import React, { useEffect, useState } from 'react';

import style from "./style.module.css";
import Text from '../../Text';

const PasswordValidator = (value) => {
    const number = /(?=.*[0-9])/;
    const upper = /(?=.*[A-Z])/;
    const lower = /(?=.*[a-z])/;
    const special = /(?=.*[#?!@$%^&*-])/;
    let error = {};
    error.number = false;
    error.uppercase = false;
    error.lowercase = false;
    error.minlength = false;
    error.special = false;
    if (value) {
        if (value.length >= 8)
            error.minlength = true
        if (number.test(value))
            error.number = true
        if (upper.test(value))
            error.uppercase = true
        if (lower.test(value))
            error.lowercase = true
        if (special.test(value))
            error.special = true
    }
    return error;
}

const checkpoints = [{
    "label": "8 Characters",
    "key": "minlength"
}, {
    "label": "Uppercase",
    "key": "uppercase"
}, {
    "label": "Lowercase",
    "key": "lowercase"
}, {
    "label": "Number",
    "key": "number"
}, {
    "label": "Special",
    "key": "special"
}]

const PasswordStrength = ({ textAlign = "left", password = "" }) => {

    const [error, setError] = useState({});

    useEffect(() => {
        setError(PasswordValidator(password));
    }, [password]);

    return (
        <div className={`${style.passwordChecker}`}>
            {
                checkpoints.map((item, i) => {
                    let valid = error[item.key] && error[item.key] === true ? true : false;
                    return (
                        <div className={style.passwordCheck} key={`password_check_${i}`}>
                            <div className={`${style.passwordCheckBox}${valid ? " " + style.passwordValid : ""}`}>
                                <div className={style.passwordCheckTick}></div>
                            </div>
                            <Text className={style.passwordCheckLabel}>{item.label}</Text>
                        </div>
                    )
                })
            }
        </div>
    )
}

export default PasswordStrength;